import { render, staticRenderFns } from "./CompositeSourceList.vue?vue&type=template&id=b57ae3ba&scoped=true"
import script from "./CompositeSourceList.vue?vue&type=script&lang=js"
export * from "./CompositeSourceList.vue?vue&type=script&lang=js"
import style0 from "./CompositeSourceList.vue?vue&type=style&index=0&id=b57ae3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57ae3ba",
  null
  
)

export default component.exports